export const SHOPPING_LIST = "shopping-list";